import React from "react";
import {
  Icon,
  StyledCell,
  StyledHeader,
  StyledTable,
  TableContainer,
} from "./table.style";
import { TableProps } from "./table.types";

const Table: React.FC<TableProps> = ({
  columns,
  data,
  actions,
  actionsColumnName,
  className,
}) => {
  return (
    <TableContainer>
      <StyledTable>
        <thead>
          <tr>
            {columns.map((column, index) => (
              <StyledHeader
                key={index}
                style={{ textAlign: column.position }}
                className={className}
              >
                {column.title.toUpperCase()}
              </StyledHeader>
            ))}
            {actions && (
              <StyledHeader className={className}>
                {actionsColumnName ? actionsColumnName : ""}
              </StyledHeader>
            )}
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {columns.map((column, colIndex) => (
                <StyledCell
                  key={colIndex}
                  style={{ textAlign: column.position }}
                  className={className}
                >
                  {row[column.key]}
                </StyledCell>
              ))}
              {actions && (
                <StyledCell style={{ textAlign: "center" }} className={className}>
                  {actions.map((action, actionIndex) => {
                    const { noAction = false } = row;
                    if (noAction) return null;

                    return (
                      <Icon
                        key={actionIndex}
                        src={action.icon}
                        onClick={() => action.onClick(row)}
                        style={{ cursor: "pointer" }}
                        alt={action.alt ? action.alt : ""}
                      />
                    );
                  })}
                </StyledCell>
              )}
            </tr>
          ))}
        </tbody>
      </StyledTable>
    </TableContainer>
  );
};

export default Table;
